import VectorProps from "./VectorProps";

export default function NumbersIcon(props: VectorProps) {
  const {
    className = "",
    handleClick = () => null,
    height,
    width,
    fill = "currentColor",
  } = props;
  return (
    <svg
      viewBox="0 0 20 20"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      height={height ?? width}
      onClick={handleClick}
      width={width}
    >
      <path
        d="M1.94705 13.975V7.87L0.352051 8.915V7.397L2.16705 6.11H3.72905V13.975H1.94705Z"
        fill={fill}
      />
      <path
        d="M6.13205 13.975V13.689L9.01405 10.642C9.77305 9.839 10.2571 9.146 10.2571 8.431C10.2571 7.782 9.89405 7.364 9.21205 7.364C8.51905 7.364 8.07905 7.771 7.95805 8.805H6.34105C6.42905 6.99 7.52905 6 9.28905 6C11.0271 6 12.0171 6.968 12.0171 8.387C12.0171 9.432 11.4121 10.29 10.4991 11.17L9.01405 12.622H12.0721V13.975H6.13205Z"
        fill={fill}
      />
      <path
        d="M16.4431 14.096C14.4411 14.096 13.4181 13.073 13.3521 11.478H14.9581C15.0241 12.237 15.4311 12.787 16.3771 12.787C17.2681 12.787 17.6861 12.358 17.6861 11.654C17.6861 10.906 17.2681 10.521 16.4211 10.521H15.8051V9.333H16.3771C17.2021 9.333 17.576 8.959 17.576 8.288C17.576 7.727 17.2131 7.309 16.4871 7.309C15.7391 7.309 15.2771 7.76 15.1891 8.497H13.6161C13.7041 7.056 14.727 6 16.5201 6C18.247 6 19.2591 6.902 19.2591 8.134C19.2591 9.014 18.7421 9.564 17.9611 9.839C18.8741 10.037 19.4901 10.686 19.4901 11.687C19.4901 13.161 18.357 14.096 16.4431 14.096Z"
        fill={fill}
      />
    </svg>
  );
}
